import { Box, Divider, List, ListItemText, Typography } from "@mui/material";
import { NavLink as RouterLink } from "react-router-dom";
import { StyledNavItem, StyledNavItemIcon } from "./styles";

interface NavSectionProps {
	data: any[];
	collapse?: boolean;
	title?: string;
}

export default function NavSection({ data = [], collapse = false, title, ...other }: NavSectionProps) {
	// Return null if no data to render
	if (data.length === 0) {
		return null;
	}

	return (
		<Box {...other}>
			{title && !collapse && (
				<Typography
					variant="overline"
					sx={{
						pl: 3.5, // Align with text after icon (icon width + spacing)
						pr: 2,
						py: 1,
						pb: 0,
						color: "text.secondary",
						display: "block",
						fontSize: "0.65rem",
						fontWeight: "fontWeightBold",
						textTransform: "uppercase",
						letterSpacing: 1.2,
						opacity: 0.72,
					}}
				>
					{title}
				</Typography>
			)}
			<List disablePadding sx={{ p: 1 }}>
				{data.map((item) => (
					<NavItem key={item.title} item={item} collapse={collapse} />
				))}
			</List>
			<Divider
				sx={{
					mx: 2,
					my: 1,
					opacity: collapse ? 0 : 1,
					transition: "opacity 0.2s ease-in-out",
				}}
			/>
		</Box>
	);
}

interface NavItemProps {
	item: any;
	collapse?: boolean;
}

function NavItem({ item, collapse }: NavItemProps) {
	const { title, path, icon, info } = item;

	return (
		<StyledNavItem
			component={RouterLink}
			to={path}
			sx={{
				justifyContent: collapse ? "center" : "flex-start",
				"&.active": {
					color: "text.primary",
					bgcolor: "action.selected",
					fontWeight: "fontWeightBold",
				},
			}}
		>
			<StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

			{!collapse && (
				<ListItemText
					disableTypography
					primary={title}
					sx={{
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}
				/>
			)}

			{!collapse && info && info}
		</StyledNavItem>
	);
}
